import { Sheet } from 'framework7-react';
import { ReactNode, useEffect, useRef, useState } from 'react';
import './f7ComponentStyle.css';

interface ModalSheetProps {
  title: string;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}
export const ModalSheet = ({
  title,
  open,
  onClose,
  children,
}: ModalSheetProps) => {
  const ModalHeader = () => {
    return (
      <div className={'modal-header'}>
        <div className={'close-button'} onClick={onClose}>
          <i className={'icon-close'} />
        </div>
        <div className={'header-label'}>
          <span>{title}</span>
        </div>
      </div>
    );
  };

  const [swipeToClose, setSwipeToClose] = useState(true);
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = modalRef.current;
    if (!el) return;

    const duration = 100;
    const handleTouchStart = () => setSwipeToClose(false);
    const handleTouchEnd = () =>
      setTimeout(() => setSwipeToClose(true), duration);

    el.addEventListener('touchstart', handleTouchStart, { passive: true });
    el.addEventListener('touchend', handleTouchEnd, { passive: true });

    return () => {
      el.removeEventListener('touchstart', handleTouchStart);
      el.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);

  return (
    <Sheet
      backdrop
      opened={open}
      onSheetClosed={onClose}
      className="modal-sheet-component"
    >
      <ModalHeader />
      <div className={'modal-body'}>{children}</div>
    </Sheet>
  );
};
